import { ReactNode } from 'react'

import { ConfirmDialog, EditListDialog } from 'shared/components'

import { SingleSelectDialogController } from '../hooks/useSingleSelectDialogController'
import SingleSelectDialogList from './SingleSelectDialogList'

interface SingleSelectDialogProps {
  open: boolean
  onClose: () => void
  confirmMessage: ReactNode
  controller: SingleSelectDialogController
}

const SingleSelectDialog = ({
  open,
  onClose,
  confirmMessage,
  controller,
}: SingleSelectDialogProps) => {
  const handleClose = () => {
    if (controller.actionLoading) return

    controller.setQuery('')
    controller.cancelAdd()
    onClose()
  }

  return (
    <>
      <EditListDialog open={open} onClose={handleClose}>
        <SingleSelectDialogList
          query={controller.query}
          setQuery={controller.setQuery}
          dataLoading={controller.dataLoading}
          actionLoading={controller.actionLoading}
          options={controller.options}
          paginationProps={controller.pagination}
          onItemClick={controller.requestAdd}
        />
      </EditListDialog>

      <ConfirmDialog
        open={controller.itemToAdd !== null}
        message={confirmMessage}
        onCancel={controller.cancelAdd}
        onConfirm={controller.confirmAdd}
        isLoading={controller.actionLoading}
      />
    </>
  )
}

export default SingleSelectDialog
